globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.AceEditor = (function() {

  function AceEditor($textarea) {
    this.$textarea = $textarea;

    utils.require([assets.aceEditor], function() {
      this.init();
    }.bind(this));
  }

  AceEditor.init = function($html) {
    $html.find('textarea.ace-editor-textarea').each(function(){
      new AceEditor($(this));
    })
  }

  AceEditor.prototype = {
    init: function() {
      var $editor = this.$textarea.parent().find('.ace-editor'),
          editor = ace.edit($editor.attr('id')),
          mode = $editor.data('mode') || 'html';

      editor.getSession().setMode('ace/mode/' + mode);
      editor.setOptions({
        minLines: 10,
        maxLines: 25
      });
      editor.setValue(this.$textarea.text(), 1);
    }
  }

  return AceEditor;
})();
